import { render, staticRenderFns } from "./RModal.vue?vue&type=template&id=5dd8165e&scoped=true&"
import script from "./RModal.vue?vue&type=script&lang=js&"
export * from "./RModal.vue?vue&type=script&lang=js&"
import style0 from "./RModal.vue?vue&type=style&index=0&id=5dd8165e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8165e",
  null
  
)

export default component.exports